'use strict'

const intentAnalysed = [
  {
    propertyName: 'intentName',
    labelName: 'nlp_intent'
  },
  {
    propertyName: 'intentDetectionConfidence',
    labelName: 'npl_confidence'
  },
  {
    propertyName: 'parameters',
    labelName: 'nlp_parameters'
  }
]

const actionDeduced = [
  {
    propertyName: 'action',
    labelName: 'deduced_action_slug'
  },
  {
    propertyName: 'stepDetails',
    labelName: 'deduced_action_step_details'
  },
  {
    propertyName: 'inProgress',
    labelName: 'action_in_progress'
  }
]

const context = [
  {
    propertyName: 'nbWelcomes',
    labelName: 'context_nb_welcomes'
  },
  {
    propertyName: 'nbChainedNotUnderstoodIntents',
    labelName: 'context_nb_not_understood'
  },
  {
    propertyName: 'nbChainedFallback',
    labelName: 'context_nb_fallback'
  },
  {
    propertyName: 'isLastActionInProgress',
    labelName: 'context_last_action_in_progress'
  }
]

const intentInfo = {
  intentAnalysed,
  actionDeduced,
  context
}
export default intentInfo
